import React, {useEffect, useState} from "react";
import t from "../../../../helpers/t";
import WidgetCheckins from "../../../dashboard/components/WidgetCheckins";
import WidgetAvailables from "../../../dashboard/components/WidgetAvailables";
import WidgetUsers from "../../../dashboard/components/WidgetUsers";
import {Biscuit} from "../../../../../utils";
import {rbac} from "../../../dashboard";

const ClientSelect = (props) => {
    const {clients, client, setClient, setReservation, setReservations, setUsers, setUser, setReservationQuery, setUserQuery, getReservationsGlobal, dispatch} = props;
    const [selectedClient, setSelectedClient] = useState(null);
    const [clientChange, setClientChange] = useState(null);
    const [dashboardSettings, setDashboardSettings] = useState({
        widgetCheckins: {isVisible: true, position: 0},
        widgetAvailables: {isVisible: true, position: 0},
        widgetUsers: {isVisible: true, position: 0},
        widgetReservations: {isVisible: true, position: 0},
        widgetResources: {isVisible: false, position: 0}
    });
    const onChange = (e) => {
        setClientChange(true);
        let temp = null;
        if(e.target.value !== null){
            temp = clients[e.target.value];
        }
        setReservations(null);
        setReservation(null);
        setUsers(null);
        setUser(null);
        setUserQuery('');
        setReservationQuery('');
        setClient(temp);
        setSelectedClient(temp);
        //getReservationsGlobal(temp);
    }
    useEffect(() => {
        if(!clientChange) return;
        setClientChange(false);
    },[selectedClient])
    return (
        <>
            <>
                <div className="inb-c-item inb-c-item--from row" key='slo'>
                        <>
                            <div className="small-6 medium-5 column">
                                <div className="input-group inb-price-input-group">
                                    <div className="float-left" style={{width:"95%"}}>
                                        <label>{t('switch')}</label>
                                        <select defaultValue={client} onChange={(e)=>{onChange(e)}}>
                                            <option value={null}>{t('switch')}</option>
                                            {clients.map((client,nr) => {
                                                return (<>
                                                    <option value={nr}>{client.organization} ({client.client_settings[0].display_name})</option>
                                                </>)
                                            })}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {selectedClient !== null && <>
                                <div id="logo" className="small-6 medium-4 column">
                                    <img id="MainLogo2"
                                         src={selectedClient?.logo}
                                         alt="Inbooma logo" />
                                </div>
                                <div className="small-6 medium-1 column">
                                    {!clientChange && <WidgetCheckins
                                        dispatch={dispatch}
                                        position={dashboardSettings.widgetCheckins.position}
                                        client_id={selectedClient?.id}
                                    />}
                                    </div>
                                <div className="small-6 medium-1 column">
                                    {!clientChange && <WidgetAvailables
                                        dispatch={dispatch}
                                        position={dashboardSettings.widgetAvailables.position}
                                        client_id={selectedClient?.id}
                                    />}
                                </div>
                                <div className="small-6 medium-1 column">
                                    {!clientChange && <WidgetUsers
                                        dispatch={dispatch}
                                        position={dashboardSettings.widgetUsers.position}
                                        client_id={selectedClient?.id}
                                    />}
                                </div>

                            </>}
                        </>
                </div>

            </>
        </>
    )
};

export default (ClientSelect);